<template>
    <div class="app-admin-wrap layout-sidebar-vertical clearfix sidebar-full">
        <system-sidebar />
        <main>
            <div
                class="main-content-wrap mt-0 bg-off-white"
                :class="{
                    'vertical-sidebar': getVerticalSidebar.isVerticalSidebar,
                    compact: getVerticalSidebar.isVerticalCompact,
                }"
            >
                <system-topbar />
                <div class="container-fluid px-0">
                    <transition name="page" mode="out-in">
                        <router-view />
                    </transition>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
import SystemSidebar from './SystemSidebar'
import SystemTopbar from './SystemTopbar'
import { mapGetters } from 'vuex'

export default {
    components: {
        SystemSidebar,
        SystemTopbar,
    },
    computed: {
        ...mapGetters(['getVerticalSidebar']),
    },
}
</script>
